import React from 'react';
import { Modal } from 'antd';
import { useToggle } from 'ahooks';
import { Image } from '../Image';

// video属性
export interface VideoItem {
    // 视频地址
    src: string;
    // 封面图
    coverUrl: string;
    // 预览动图
    previewUrl?: string;
    className?: string;
    [key: string]: any;
}

export const Video: React.FC<VideoItem> = (props) => {
    const [isModalOpen, { toggle }] = useToggle();
    const { src, coverUrl, previewUrl = '', className = '' } = props
    return <>
        <Image onClick={toggle} isClick={false} className={className} src={previewUrl || coverUrl} thumbnail={coverUrl}></Image>
        <Modal
            width={600}
            open={isModalOpen}
            destroyOnHidden
            footer={false}
            onCancel={toggle}
        >
            <video className='w-full h-[600px]' src={src} controls autoPlay></video>
        </Modal>
    </>
};

